module.exports = __webpack_public_path__ + "img/circle_error.a558334c.svg";